import StateDropdown from "../../../RenewalQuestionnaireComp/DriversOHM/StateDropdown"
import NameRegisteredDropdown from "../../VehicleDropdowns/NameRegisteredDropdown"
import VehicleLeasingList from "../../VehicleDropdowns/VehicleLeasingList"
import VehicleAddMI_Coverages from "./VehicleAddMI_Coverages"
import VehiclePersonInfo from "./VehiclePersonInfo"

const VehicleAddMI_Leased = ({ vehicleAddContext, context }) => {

    return (
        <>
            {/* Leasing Company Name */}
            <div className="row form-group form-group-sm align-items-center my-3">
                <div className="col-6 text-primary fw-bold">
                    Leasing Company Name*
                </div>
                <div className="col-sm-8 col-md-6">
                    <select className="btn btn-default btn-group dropdown-toggle filter-option mt-2"
                        value={vehicleAddContext.newVehicle?.vehicleLeasingCompany}
                        onChange={(e) => vehicleAddContext.saveAddition("vehicleLeasingCompany", e.target.value)}
                    >
                        <option value={""} disabled>Select from the following...</option>
                        {VehicleLeasingList()}
                    </select>
                </div>
            </div>

            {/* Co-Leased */}
            <div className="row form-group form-group-sm align-items-center my-3">
                <div className="col-6 text-primary fw-bold">
                    Is this vehicle co-leased?*
                </div>
                <div className="col-md-6 col-sm-8 px-0 pb-1">
                    <div className="radio-inline form-check-inline px-3 mx-0">
                        <label>
                            <input type={"radio"} className="form-check-input me-2" name="coLeased" value={"1"}
                                checked={(vehicleAddContext?.newVehicle?.coLeased === "1") ? vehicleAddContext?.newVehicle?.coLeased : ""}
                                onChange={(e) => vehicleAddContext.saveAddition("coLeased", e.target.value)}
                            />Yes
                        </label>
                    </div>
                    <div className="radio-inline form-check-inline">
                        <label>
                            <input type={"radio"} className="form-check-input me-2" name="coLeased" value={"0"}
                                checked={(vehicleAddContext?.newVehicle?.coLeased === "0") ? vehicleAddContext?.newVehicle?.coLeased : ""}
                                onChange={(e) => vehicleAddContext.saveAddition("coLeased", e.target.value)}
                            />No
                        </label>
                    </div>
                </div>
            </div>

            {/* Co-Leasee Info */}
            {vehicleAddContext?.newVehicle?.coLeased == "1" &&
                <VehiclePersonInfo vehicleAddContext={vehicleAddContext} type={"Co-Leasee"} />
            }

            {/* Vehicle Registered to PERSON Dropdown */}
            <div className="row form-group form-group-sm align-items-center my-4">
                <div className="text-primary fw-bold">
                    In what name is (will) the vehicle be registered?
                </div>
                <div className="col-8">
                    <select className="col-sm-12 btn btn-default btn-group dropdown-toggle filter-option mt-2"
                        value={vehicleAddContext?.newVehicle?.nameRegistered}
                        onChange={(e) => vehicleAddContext.saveAddition("nameRegistered", e.target.value)}
                    >
                        {NameRegisteredDropdown()}
                    </select>
                </div>
            </div>

            {/* Name Registered as None of the Above */}
            {vehicleAddContext?.newVehicle?.nameRegistered == "43095" &&
                <VehiclePersonInfo vehicleAddContext={vehicleAddContext} type={"Registrant"} />
            }
            {/* Vehicle Registered to STATE Dropdown */}
            <div className="row form-group form-group-sm align-items-center my-4">
                <div className="text-primary fw-bold">
                    In what state is (will) the vehicle be registered?*
                </div>
                <div className="col-8">
                    <select className="col-sm-12 btn btn-default btn-group dropdown-toggle filter-option mt-2"
                        value={vehicleAddContext?.newVehicle?.stateRegistered}
                        onChange={(e) => vehicleAddContext.saveAddition("stateRegistered", e.target.value)}
                    >
                        {StateDropdown()}
                    </select>
                </div>
            </div>

            <VehicleAddMI_Coverages vehicleAddContext={vehicleAddContext} context={context} />
        </>
    )
}

export default VehicleAddMI_Leased